import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { List } from 'immutable';
import { BaseDataService, BaseUpdateComponent, ModalService, NotificationService, QueryParameter } from 'yt-ng-framework';
import { Provajder } from '../../orgjeddefgini/userprovajder/provajder/provajder';
import { UserProvajder } from '../../orgjeddefgini/userprovajder/userprovajder';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-userprovajder-update',
  templateUrl: './userprovajder-update.component.html'
})
export class UserprovajderUpdateComponent extends BaseUpdateComponent<UserProvajder> implements OnInit {

  parameterList: List<QueryParameter> = List([]);
  OrgJedID: QueryParameter = new QueryParameter();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService,modalService)
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("FirmaID", Validators.required, 'required', 'USERPROVAJDER.FIRMA.VALIDATION.REQUIRED');
    this.addValidatorToFc("UserId", Validators.required, 'required', 'USERPROVAJDER.USER.VALIDATION.REQUIRED');
    this.addValidatorToFc("SefProvajderId", Validators.required, 'required', 'USERPROVAJDER.PROVAJDER.VALIDATION.REQUIRED');

    // this.OrgJedID.Name = "orgjedid";
    // this.OrgJedID.Value = this.Item.ID;
    

    this.IDProcessed
    .subscribe((value) => {
      if(value && this.Item.ID == -1){
        //this.baseFormGroup.patchValue()
        this.baseFormGroup.get('SefProvajderId').enable();
        this.baseFormGroup.get('SefProvajderId').updateValueAndValidity();
        this.baseFormGroup.get('UserId').enable();
        this.baseFormGroup.get('UserId').updateValueAndValidity();
        this.baseFormGroup.get('DocloopSoftwareId').enable();
        this.baseFormGroup.get('DocloopSoftwareId').updateValueAndValidity();
        this.baseFormGroup.get('Username').enable();
        this.baseFormGroup.get('Username').updateValueAndValidity();
        this.baseFormGroup.get('Password').enable();
        this.baseFormGroup.get('Password').updateValueAndValidity();
        this.baseFormGroup.get('ApiKey').enable();
        this.baseFormGroup.get('ApiKey').updateValueAndValidity();
        this.baseFormGroup.get('FirmaID').disable();
        this.baseFormGroup.get('FirmaID').updateValueAndValidity();
        this.loadFirma();
      }else{
        this.baseFormGroup.get('SefProvajderId').disable();
        this.baseFormGroup.get('SefProvajderId').updateValueAndValidity();
        this.baseFormGroup.get('UserId').disable();
        this.baseFormGroup.get('UserId').updateValueAndValidity();
        this.baseFormGroup.get('FirmaID').disable();
        this.baseFormGroup.get('FirmaID').updateValueAndValidity();
        this.loadFirma();
        // this.OrgJedID.Value = -1;
        // this.OrgJedID.Name= "orgjedid";
        // this.parameterList = this.parameterList.push(this.OrgJedID);
      }
    })
  }

  onProvajderSelected(value: Provajder){
    setTimeout(() => {

      if(value != null && value.GenericName == "Docloop_t"){
        // this.baseFormGroup.get('ProvajderId').disable();
        // this.baseFormGroup.get('ProvajderId').updateValueAndValidity();
        this.baseFormGroup.get('Username').enable();
        this.baseFormGroup.get('Username').updateValueAndValidity();
        this.baseFormGroup.get('Password').enable();
        this.baseFormGroup.get('Password').updateValueAndValidity();
        this.baseFormGroup.get('DocloopSoftwareId').disable();
        this.baseFormGroup.get('DocloopSoftwareId').updateValueAndValidity();
        this.baseFormGroup.patchValue({DocloopSoftwareId: 'Yuteam-001'});
        this.baseFormGroup.get('ApiKey').disable();
        this.baseFormGroup.get('ApiKey').updateValueAndValidity();
        this.baseFormGroup.get('ApiKey').reset();
        this.addValidatorToFc("FirmaID", Validators.required, 'required', 'USERPROVAJDER.FIRMA.VALIDATION.REQUIRED');
        this.addValidatorToFc("Username", Validators.required, 'required', 'USERPROVAJDER.USERNAME.VALIDATION.REQUIRED');
        this.addValidatorToFc("Password", Validators.required, 'required', 'USERPROVAJDER.PASSWORD.VALIDATION.REQUIRED');
      }

      if(value != null && value.GenericName == "Docloop_p"){
        // this.baseFormGroup.get('ProvajderId').disable();
        // this.baseFormGroup.get('ProvajderId').updateValueAndValidity();
        this.baseFormGroup.get('Username').enable();
        this.baseFormGroup.get('Username').updateValueAndValidity();
        this.baseFormGroup.get('Password').enable();
        this.baseFormGroup.get('Password').updateValueAndValidity();
        this.baseFormGroup.get('DocloopSoftwareId').disable();
        this.baseFormGroup.get('DocloopSoftwareId').updateValueAndValidity();
        this.baseFormGroup.patchValue({DocloopSoftwareId: 'Yuteam-001'});
        this.baseFormGroup.get('ApiKey').disable();
        this.baseFormGroup.get('ApiKey').updateValueAndValidity();
        this.baseFormGroup.get('ApiKey').reset();
        this.addValidatorToFc("Username", Validators.required, 'required', 'USERPROVAJDER.USERNAME.VALIDATION.REQUIRED');
        this.addValidatorToFc("Password", Validators.required, 'required', 'USERPROVAJDER.PASSWORD.VALIDATION.REQUIRED');
       
      }

      if(value != null && value.GenericName == "Sef_t"){
        // this.baseFormGroup.get('ProvajderId').disable();
        // this.baseFormGroup.get('ProvajderId').updateValueAndValidity();
        this.addValidatorToFc("ApiKey", Validators.required, 'required', 'USERPROVAJDER.APIKEY.VALIDATION.REQUIRED');
        this.baseFormGroup.get('Username').disable();
        this.baseFormGroup.get('Username').updateValueAndValidity();
        this.baseFormGroup.get('Password').disable();
        this.baseFormGroup.get('Password').updateValueAndValidity();
        this.baseFormGroup.get('DocloopSoftwareId').disable();
        this.baseFormGroup.get('DocloopSoftwareId').updateValueAndValidity();
        this.baseFormGroup.get('ApiKey').enable();
        this.baseFormGroup.get('ApiKey').updateValueAndValidity();
        this.baseFormGroup.get('DocloopSoftwareId').reset();
        this.baseFormGroup.get('Username').reset();
        this.baseFormGroup.get('Password').reset();
      }

      if(value != null && value.GenericName == "Sef_p"){
        // this.baseFormGroup.get('ProvajderId').disable();
        // this.baseFormGroup.get('ProvajderId').updateValueAndValidity();
        this.addValidatorToFc("ApiKey", Validators.required, 'required', 'USERPROVAJDER.APIKEY.VALIDATION.REQUIRED');
        this.baseFormGroup.get('Username').disable();
        this.baseFormGroup.get('Username').updateValueAndValidity();
        this.baseFormGroup.get('Password').disable();
        this.baseFormGroup.get('Password').updateValueAndValidity();
        this.baseFormGroup.get('DocloopSoftwareId').disable();
        this.baseFormGroup.get('DocloopSoftwareId').updateValueAndValidity();
        this.baseFormGroup.get('ApiKey').enable();
        this.baseFormGroup.get('ApiKey').updateValueAndValidity();
        this.baseFormGroup.get('DocloopSoftwareId').reset();
        this.baseFormGroup.get('Username').reset();
        this.baseFormGroup.get('Password').reset();
      }
    })
  }

  loadFirma(){
      var _parentProperty = this.ParentProperty.Value;

      if(_parentProperty == undefined){
        this.OrgJedID.Value = -1;//this.Item.ID;
        this.OrgJedID.Name= "orgjedid";
        this.parameterList = this.parameterList.push(this.OrgJedID);
    }
      else{
        this.OrgJedID.Value = _parentProperty;//this.Item.ID;
        this.OrgJedID.Name= "orgjedid";
        this.parameterList = this.parameterList.push(this.OrgJedID);
      }
    } 

}
